import React from 'react';
import './TutorialVideosContent.css';

export function TutorialVideosContent({ children, searchTerm, onSearchChange }) {
  return (
    <div className="tutorial-videos-content-wrapper">
      {/* Search bar is rendered by parent now */}
      {children}
    </div>
  );
}